import React from 'react';
import {useSelector} from 'react-redux';

import {COLUMNS} from '../../constants';
import {useGetUserConferencesLicensedUsers} from '../../hooks/useUserConferencesLicensedUsers';
import {userConferencesResultSelector} from '../../slices/user-conferences.slice';

import {HeaderCaption} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';


type Props = {
    accountIds: number[],
    totalCount: number,
};

const LicensedEnabledUsersHeaderController = ({accountIds, totalCount}: Props) => {
    const {isLoading, loadingError} = useGetUserConferencesLicensedUsers({accountIds, totalCount});

    return (
        <HeaderCaption
            isLoading={isLoading}
            loadingError={loadingError}
            columnId={COLUMNS.LICENSED_ENABLED_USERS}
        />
    );
};

export const LicensedEnabledUsersHeader = () => {
    const result = useSelector(userConferencesResultSelector);

    return result ? (
        <LicensedEnabledUsersHeaderController
            accountIds={result.data.map(({accountId}) => accountId)}
            totalCount={result.totalCount}
        />
    ) : (
        <HeaderSkeleton columnId={COLUMNS.LICENSED_ENABLED_USERS}/>
    );
};
